export enum ModalType {
  SITE_ANNOUNCEMENT = "SiteAnnouncement",
  BALANCE_TRANSFER = "BalanceTransfer",
  BALANCE = "Balance",
  SETTING = "Setting",
  BETS = "Bets",
  FANCYBET_BOOK = "FancyBetBook",
  FANCYBET_BOOK_UNAVAILABLE = "FancyBetBookUnavailable",
  FANCYBET_RULE_UNAVAILABLE = "FancyBetRuleUnavailable",
  FANCYBET_RULE = "FancyBetRule",
  ELECTION_FANCYEBT_RULE = "ElectionFancyBetRule",
  SPORTS_BOOK_RULE = "SportsBookRule",
  GENIUS_SPORTS_RULE = "GeniusSportsRule",
  KYC = "KYC",
  ABOUT_US = "AboutUs",
  PRIVACY_POLICY = "PrivacyPolicy",
  RESPONSIBLE_GAMING = "ResponsibleGaming",
  TERMS_AND_CONDITIONS = "TermsAndConditions",
  UNDERAGE_GAMING_POLICY = "UnderageGamingPolicy",
  SELF_EXCLUSION_POLICY = "SelfExclusionPolicy",
  RULES_AND_REGULATIONS = "RulesAndRegulations",
  TERMS = "Terms",
  CONFIRM_BETS = "ConfirmBets",
  ANNOUNCEMENT = "Announcement",
  MARKET_DEPTH = "MarketDepth",
  CASINO_IFRAME = "CasinoIframe",
  MINI_GAME = "MiniGame",
  SEARCH = "Search",
  DOWNLOAD_APP = "DownloadApp",
  LOGIN = "Login",
  VENDOR_REPORT = "VendorReport",
  NOTICE = "Notice",
  LOGIN_TO_PROCEED = "LoginToProceed",
  RESET_PASSWORD = "ResetPassword",
  GENIUSSPORTS_SPORTSBOOK = "GeniusSportsSportsBook"
}
export enum ModalTransition {
  FADE = "fade",
  SLIDE_FADE_TOP = "slide-fade-top",
  SLIDE_FADE_LEFT = "slide-fade-left",
  SLIDE_FADE_RIGHT = "slide-fade-right",
  NONE = ""
}

export enum ModalMode {
  DIALOG = "dialog",
  POPUP = "popup",
  PAGE = "page"
}

export default ModalType
